var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import AccessStatsItemsList from './AccessStatsItemsList';
import PlainButton from '../../components/plain-button/PlainButton';

import messages from './messages';

import './AccessStats.scss';

var AccessStats = function AccessStats(_ref) {
    var _ref$commentCount = _ref.commentCount,
        commentCount = _ref$commentCount === undefined ? 0 : _ref$commentCount,
        _ref$commentStatButto = _ref.commentStatButtonProps,
        commentStatButtonProps = _ref$commentStatButto === undefined ? {} : _ref$commentStatButto,
        _ref$downloadCount = _ref.downloadCount,
        downloadCount = _ref$downloadCount === undefined ? 0 : _ref$downloadCount,
        _ref$downloadStatButt = _ref.downloadStatButtonProps,
        downloadStatButtonProps = _ref$downloadStatButt === undefined ? {} : _ref$downloadStatButt,
        _ref$editCount = _ref.editCount,
        editCount = _ref$editCount === undefined ? 0 : _ref$editCount,
        _ref$editStatButtonPr = _ref.editStatButtonProps,
        editStatButtonProps = _ref$editStatButtonPr === undefined ? {} : _ref$editStatButtonPr,
        errorMessage = _ref.errorMessage,
        _ref$hasCountOverflow = _ref.hasCountOverflowed,
        hasCountOverflowed = _ref$hasCountOverflow === undefined ? false : _ref$hasCountOverflow,
        _ref$isBoxNote = _ref.isBoxNote,
        isBoxNote = _ref$isBoxNote === undefined ? false : _ref$isBoxNote,
        openAccessStatsModal = _ref.openAccessStatsModal,
        _ref$previewCount = _ref.previewCount,
        previewCount = _ref$previewCount === undefined ? 0 : _ref$previewCount,
        _ref$previewStatButto = _ref.previewStatButtonProps,
        previewStatButtonProps = _ref$previewStatButto === undefined ? {} : _ref$previewStatButto,
        _ref$viewMoreButtonPr = _ref.viewMoreButtonProps,
        viewMoreButtonProps = _ref$viewMoreButtonPr === undefined ? {} : _ref$viewMoreButtonPr,
        _ref$viewStatButtonPr = _ref.viewStatButtonProps,
        viewStatButtonProps = _ref$viewStatButtonPr === undefined ? {} : _ref$viewStatButtonPr;
    return React.createElement(
        'div',
        { className: 'access-stats' },
        errorMessage ? React.createElement(
            'p',
            null,
            errorMessage
        ) : React.createElement(
            React.Fragment,
            null,
            React.createElement(AccessStatsItemsList, {
                commentCount: commentCount,
                commentStatButtonProps: commentStatButtonProps,
                downloadCount: downloadCount,
                downloadStatButtonProps: downloadStatButtonProps,
                editCount: editCount,
                editStatButtonProps: editStatButtonProps,
                hasCountOverflowed: hasCountOverflowed,
                isBoxNote: isBoxNote,
                openAccessStatsModal: openAccessStatsModal,
                previewCount: previewCount,
                previewStatButtonProps: previewStatButtonProps,
                viewStatButtonProps: viewStatButtonProps
            }),
            openAccessStatsModal && React.createElement(
                PlainButton,
                _extends({
                    className: 'lnk access-stats-view-details',
                    onClick: openAccessStatsModal
                }, viewMoreButtonProps),
                React.createElement(FormattedMessage, messages.accessStatsViewDetails)
            )
        )
    );
};

AccessStats.propTypes = {
    commentCount: PropTypes.number,

    /**
     * Props for comment stat PlainButton
     */
    commentStatButtonProps: PropTypes.object,
    downloadCount: PropTypes.number,

    /**
     * Props for download stat PlainButton
     */
    downloadStatButtonProps: PropTypes.object,
    editCount: PropTypes.number,

    /**
     * Props for edit stat PlainButton
     */
    editStatButtonProps: PropTypes.object,
    errorMessage: PropTypes.string,
    hasCountOverflowed: PropTypes.bool,
    isBoxNote: PropTypes.bool,

    /**
     * A function that opens the access stats modal
     */
    openAccessStatsModal: PropTypes.func,
    previewCount: PropTypes.number,

    /**
     * Props for preview stat PlainButton
     */
    previewStatButtonProps: PropTypes.object,

    /**
     * Props for View More PlainButton
     */
    viewMoreButtonProps: PropTypes.object,

    /**
     * Props for view stat PlainButton
     */
    viewStatButtonProps: PropTypes.object
};
export default AccessStats;
import PropTypes from 'prop-types';